import { Controller } from "@hotwired/stimulus"
import { withReturnOrigin, stripFrom, currentOrigin } from "../helpers/return_origin"

export default class extends Controller {
  connect() {
    this.applyClientState()
    this.boundReapplyAfterMorph = this.applyClientState.bind(this)
    document.addEventListener("turbo:morph", this.boundReapplyAfterMorph)
  }

  disconnect() {
    if (this.boundReapplyAfterMorph) document.removeEventListener("turbo:morph", this.boundReapplyAfterMorph)
  }

  applyClientState() {
    const href = this.element.getAttribute("href")
    if (!href) return

    this.element.setAttribute("href", withReturnOrigin(stripFrom(href), currentOrigin()))
  }
}
